import WidgetError from "auto-widget-framework/src/Error/WidgetError";

export default class Number {

  /**
   * Formats number.
   *
   * Examples for 100,000.9999999 as input:
   *  format=",###.##]" -> 100,000.99
   *  format=",###.]" -> 100,000.9999999
   *  format=",###" -> 100,000
   *  format=" ####.#" -> 10 0000.9
   *
   * @param {number} value
   * @param {string} format
   * @return {string}
   */
  static format (value, format) {
    const NUMBERS_MATCH = /#+/g;

    if ((value === undefined) || (typeof value !== 'number') || (format === undefined)) {
      throw new WidgetError(`Missing value or format for number formatting.`);
    }

    if (!format) {
      throw new WidgetError(`Incorrect number format.`);
    }

    let [thousandSeparator, decimalSeparator] = format.split(NUMBERS_MATCH);
    let thousandCount = NUMBERS_MATCH.exec(format)[0].length;
    let decimalCount = NUMBERS_MATCH.exec(format);
    decimalCount = decimalCount ? decimalCount[0].length : undefined;

    const integer = Math.abs(Math.floor(value));
    const sign = value < 0 ? "-" : "";
    const decimal = value - Math.floor(value);

    const stringParts = [
      sign + String(integer).split("").reverse().join("")
        .split(new RegExp(`(.{1,${thousandCount}})`, 'g')).filter((v) => v)
        .join(thousandSeparator).split("").reverse().join("")
    ];

    if (decimalSeparator) {
      let decimalString = "";

      if (decimalCount) {
        decimalString = ("0".repeat(decimalCount) + decimal.toFixed(decimalCount).substr(2)).substr(decimalCount);
      } else {
        decimalString = String(decimal).substr(2);
      }

      if (decimalString) {
        stringParts.push(decimalSeparator, decimalString);
      }
    }

    return stringParts.join("");
  }

}
